export default __webpack_public_path__ + "static/media/keto_cravings@3x.dcd54191.jpg";